import { render, staticRenderFns } from "./estadisticas-inicio.vue?vue&type=template&id=417ee699&scoped=true&"
import script from "./estadisticas-inicio.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-inicio.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-inicio.vue?vue&type=style&index=0&id=417ee699&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ee699",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
